import { async } from "@firebase/util";
import { getDatabase, ref, child, get, update} from "firebase/database";




export const get_all_events = async (uid) => {
    const dbRef = ref(getDatabase());
    const posts = await get(child(dbRef, `Events/${uid}/`)).then((snapshot) => {
        if (snapshot.exists()) {
          console.log("hioomdsfsd")       
          return snapshot.val();
        } else {
          
            return([])          
        }
      }).catch((error) => {         
        console.error(error);
        return([])          
      });
    return(posts)    
        
}

export const getUserData = async(uid) => {
  const dbRef = ref(getDatabase());  
  const userData = await get(child(dbRef, `Users/${uid}`)).then((snapshot) => {
      if (snapshot.exists()) {          
        return snapshot.val();
      } else {
          console.log("No data available");
          return([])          
      }
    }).catch((error) => {        
      console.log(error);
      return([])          
    });    
  
  return(userData)
}